export default __webpack_public_path__ + "static/media/mr2.198a138b.jpg";